import React from 'react'
import { useFadeTransition } from './hooks/useFadeTransition';

export const FadeWrapper = ({ show, duration = 300, delay = 0, children, keepMounted = false }) => {
  const { shouldRender, isAnimating } = useFadeTransition(show, duration);

  if (!shouldRender && !keepMounted) return null;

  return (
    <div
      style={{
        transition: `opacity ${duration}ms ease-in-out ${delay}ms`,
        opacity: isAnimating ? 1 : 0,
        pointerEvents: isAnimating ? 'auto' : 'none', // Deshabilitar clicks cuando está oculto
      }}
    >
      {children}
    </div>
  );
};